import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class KbGetAQuoteService {
  private http = inject(HttpClient);
  private occ = inject(OccEndpointsService);
  popUpCaller: any;
  yes: boolean = false;
  globalMsg = undefined;
  cancelMsg: boolean = false;
  stateMaintenance: any;
  createQuoteId(productCode: string, newOne: boolean, quoteCode?) {
    if (newOne) {
      return this.http.get(this.occ.buildUrl(`quote/createQuoteSLP?productCode=${productCode}`));
    } else {
      return this.http.get(this.occ.buildUrl(`quote/createQuoteSLP?productCode=${productCode}&quoteCode=${quoteCode}`));
    }
  }

  getDataWithQuoteId(quoteId: string) {
    return this.http.get(this.occ.buildUrl(`quote/myquotes/details?quoteCode=${quoteId}`));

  }
  cancelQuote(quoteCode: string) {
    return this.http.post(this.occ.buildUrl(`quote/cancel?quoteCode=${quoteCode}`), null);
  }

  submitQuote(quoteCode: string, PayLoad?: any) {
    return this.http.post(this.occ.buildUrl(`quote/submit?quoteCode=${quoteCode}`), { quoteForm: PayLoad });
  }

  removeProductFromQuote(entryNumber, quoteCode) {
    return this.http.get(this.occ.buildUrl(`quote/deleteEntry?entryNumber=${entryNumber}&quoteCode=${quoteCode}`));
  }
}
